export const errorMessages = {
  favoriteNoArea:
    'お気に入りの検索条件に存在しないエリアが指定されています。\n正しいエリアを選択して検索を再度行い、お気に入りに保存してください。',
} as const;
